import { getTaskList, TaskListItem, cancelTask } from '@/api/sys/project/jobTask';
import { getField, updateField } from '@/libs/vuexHelper';
import { uniqBy, cloneDeep } from 'lodash';
import { LooseTaskListItem, normalizeTaskListItem } from '@/api/sys/project/task-normalizer';

interface StateType {
    completedList: TaskListItem[];
    underwayList: TaskListItem[];
    isCompletedNext: boolean;
    isUnderwayNext: boolean;
    slideId: string;
    showTaskCenter: boolean;
}

const initState = (): StateType => {
    return {
        completedList: [],
        underwayList: [],
        isCompletedNext: false,
        isUnderwayNext: false,
        slideId: '',
        showTaskCenter: false,
    };
};

const getFlagIndex = (item: TaskListItem, list: TaskListItem[]) => {
    const indexs: number[] = [];
    for (let i = 0; i < list.length; i += 1) {
        if (Number(list[i].id) > Number(item.id)) {
            indexs.push(i);
        }
    }
    const flagIndex = indexs.length > 0 ? Math.max(...indexs) : -1;
    return flagIndex;
};

let slideIdTimer: number;

const normalizeTaskList = (list: LooseTaskListItem[]) => list.map(normalizeTaskListItem);

export default {
    namespaced: true,
    state: initState(),
    getters: { getField },
    mutations: {
        updateField,
        setTaskList(state: StateType, { list, type }: { list: TaskListItem[], type: 'completed' | 'underway' }) {
            if (type === 'completed') {
                state.completedList = list;
            } else if (type === 'underway') {
                state.underwayList = list;
            }
        },
        setIsNext(state: StateType, { isNext, type }: { isNext: boolean, type: 'completed' | 'underway' }) {
            if (type === 'completed') {
                state.isCompletedNext = isNext;
            } else if (type === 'underway') {
                state.isUnderwayNext = isNext;
            }
        },
        setSlideId(state: StateType, payload: { slideId: string }) {
            state.slideId = payload.slideId;
        },
    },
    actions: {
        getTaskListAction({ commit, state }: any, { params, isInit }: {params: any, isInit?: boolean}) {
            const { tab_type } = params;
            return new Promise((resolve, reject) => {
                getTaskList(params).then((res) => {
                    const { list, total } = res.data.data;
                    const normalizedIncoming = normalizeTaskList(list);
                    const isCompleted = tab_type === '0';
                    const incoming = isCompleted ? normalizedIncoming : normalizedIncoming.filter(
                        (task) => !state.completedList.some((completed: TaskListItem) => completed.id === task.id),
                    );
                    let taskList: TaskListItem[] = tab_type === '0' ? state.completedList : state.underwayList;
                    let isNext = tab_type === '0' ? state.isCompletedNext : state.isUnderwayNext;
                    if (isInit) {
                        taskList = incoming;
                    } else {
                        taskList = taskList.concat(incoming);
                    }

                    taskList = uniqBy(taskList, 'id');

                    taskList = taskList.sort((a, b) => Number(b.id) - Number(a.id));

                    isNext = taskList.length < total;

                    const commitType = tab_type === '0' ? 'completed' : 'underway';
                    commit('setTaskList', { list: taskList, type: commitType });
                    if (isCompleted) {
                        const underwayList = state.underwayList.filter(
                            (item: TaskListItem) => !taskList.some((task) => task.id === item.id),
                        );
                        commit('setTaskList', { list: underwayList, type: 'underway' });
                    }
                    commit('setIsNext', { isNext, type: commitType });

                    resolve(res);
                }).catch((err) => {
                    reject(err);
                });
            });
        },
        joinTask({ commit, state }: any, { item, to_type }: {item: LooseTaskListItem, to_type: '0' | '1'}) {
            let taskList: TaskListItem[] = to_type === '0' ? cloneDeep(state.completedList) : cloneDeep(state.underwayList);
            const normalizedItem = normalizeTaskListItem(item);
            if (to_type === '1' && state.completedList.some((task: TaskListItem) => task.id === normalizedItem.id)) {
                return;
            }
            const index = taskList.findIndex((x) => x.id === normalizedItem.id);
            if (index === -1) {
                taskList.unshift(normalizedItem);
            } else if (!(taskList[index].status === '4' && normalizedItem.status === '1')) {
                taskList.splice(index, 1, normalizedItem);
            }
            taskList = uniqBy(taskList, 'id');

            taskList = taskList.sort((a, b) => Number(b.id) - Number(a.id));

            commit('setSlideId', { slideId: normalizedItem.id });

            commit('setTaskList', { list: taskList, type: to_type === '0' ? 'completed' : 'underway' });

            // 不管有没有执行过渡动画，在1s后清除
            slideIdTimer = window.setTimeout(() => {
                commit('setSlideId', { slideId: '' });
                clearTimeout(slideIdTimer);
            }, 1000);
        },
    },
};
